<template>
  <div id="certifications">
    <b-container style="margin-top: 100px; margin-bottom: 100px;">
      <b-row>
        <!-- <b-col lg="3" md="4" style="text-align: center;">
          Professional Experience
        </b-col> -->
        <b-col lg="12" md="12">
            
            <div style="margin-bottom: 50px;" v-scroll-reveal="{ delay: 100 }">
              <h2 class="section-title">Certifications</h2>
              <!-- <p class="text-gray">Firms I've worked with, etc. etc.</p> -->
            </div>
            <div>

              <div v-scroll-reveal="{ delay: 100 }">

                <p class="skill-chip" style="width: fit-content;">
                  Strategic Communication Campaigns Specialization
                </p>
                <div style="margin-left: 10px;">
                  <div style="margin-top: -8px; color: #333;">
                    University of Colorado Boulder
                  </div>
                  <div style="font-size: 12px; color: #999;">
                    1.26.26
                  </div>
                </div>


                <p class="skill-chip" style="width: fit-content; margin-top: 30px;">
                  Public Relations and Communications Associate Professional
                </p>
                <div style="margin-left: 10px;">
                  <div style="margin-top: -8px; color: #333;">
                    Microsoft
                  </div>
                  <div style="font-size: 12px; color: #999;">
                    12.15.25
                  </div>
                </div>


                <p class="skill-chip" style="width: fit-content; margin-top: 30px;">
                  Digital Media and Marketing strategies
                </p>
                <div style="margin-left: 10px;">
                  <div style="margin-top: -8px; color: #333;">
                    University of Illinois Urbana-Champaign
                  </div>
                  <div style="font-size: 12px; color: #999;">
                    9/24/24
                  </div>
                </div>


                <p class="skill-chip" style="width: fit-content; margin-top: 30px;">
                  The Digital Marketing Revolution
                </p>
                <div style="margin-left: 10px;">
                  <div style="margin-top: -8px; color: #333;">
                    University of Illinois Urbana-Champaign
                  </div>
                  <div style="font-size: 12px; color: #999;">
                    7/24/24
                  </div>
                </div>

              </div>
            </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {BRow, BCol, BContainer, BCard, } from 'bootstrap-vue'
export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
  },
  data() {
    return {
      skillItems: [
        {
          img: '/wordlogo.png',
          text: 'MS Word'
        },
        {
          img: '/excellogo.png',
          text: 'MS Excel'
        },
        {
          img: '/abacuslogo.png',
          text: 'Abacus Law'
        },
        {
          img: '/lexisnexis.png',
          text: 'Lexis Nexis'
        },
      ]
    }
  }
}
</script>

<style lang="css">



</style>
